import HeaderImage from "../img/myked_header_850.png";
import Navbar from "react-bootstrap/Navbar";
import { trackEvent, setPendingEntryMethod, EVENTS } from "../analytics";

export default function Header({ activeSection = 'home' }) {
  const trackNavClick = (section, clickSource = 'nav_link') => {
    setPendingEntryMethod('nav_click');
    trackEvent(EVENTS.NAV_CLICK, {
      target_section: section,
      click_source: clickSource,
      from_section: activeSection,
      scroll_y: window.scrollY,
      current_hash: window.location.hash || 'none',
    });
  };
  return (
    <header>
      <Navbar bg="light" fixed="top" id="navbar" className="m-0 p-0">
        <nav
          style={{ justifyContent: "center" }}
          className="navbar navbar-expand-lg"
        >
          <a className="navbar-brand p-3" href="#home" onClick={() => trackNavClick('home', 'brand_logo')}>
            <img src={HeaderImage} className="img-responsive" alt="Myke D - Marketing Solutions Engineer Portfolio Header" />
          </a>

          <ul
            style={{ justifyContent: "center" }}
            className="navbar-nav mr-auto mt-2 mt-lg-0"
          >
            <li className="nav-item">
              <a 
                className={`nav-link ${activeSection === 'home' ? 'active-scroll-spy' : ''}`} 
                href="#home"
                onClick={() => trackNavClick('home')}
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'about' ? 'active-scroll-spy' : ''}`}
                href="#about"
                onClick={() => trackNavClick('about')}
              >
                About
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'projects' ? 'active-scroll-spy' : ''}`}
                href="#projects"
                onClick={() => trackNavClick('projects')}
              >
                Projects
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'contact' ? 'active-scroll-spy' : ''}`}
                href="#contact"
                onClick={() => trackNavClick('contact')}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </Navbar>
    </header>
  );
}
